import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';
//import moment from 'moment';

@Pipe({
    name: 'formatDate',
    pure: false
})
@Injectable()
export class FormatDate implements PipeTransform {

    transform(date: string, format: string): string {
        //return moment(date).format(format);
      return "";
    }
}
